var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotValid = function SvgNotValid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 22.118.882.882 3.128-3.129L19.118 23l.882-.882-3.129-3.128L20 15.882 19.118 15l-3.108 3.129L12.882 15l-.882.882 3.129 3.108z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.41 28.333a2.33 2.33 0 0 1-1.71-.7 2.33 2.33 0 0 1-.7-1.71V5.41q0-1.01.7-1.71A2.33 2.33 0 0 1 8.41 3H19l7 7v15.923q0 1.011-.7 1.71t-1.71.7zM18 11V5H8.41a.4.4 0 0 0-.282.128A.4.4 0 0 0 8 5.41v20.513q0 .154.128.282.129.128.282.128h15.18a.4.4 0 0 0 .282-.128.4.4 0 0 0 .128-.282V11z",
    clipRule: "evenodd"
  })));
};
export default SvgNotValid;